import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { Eap, EapLedPattern } from 'icreate/common/models/eap';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class EapService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getList(vesselId: string) {
        return await lastValueFrom(
            this.http.get<Eap[]>(`${this.domain}/api/eap`, {
                headers: this.headers,
                params: { vesselId },
            })
        );
    }

    async save(eapDatList: Eap[], vesselId) {
        return await lastValueFrom(
            this.http.put(`${this.domain}/api/eap/save/${vesselId}`, eapDatList, {
                headers: this.headers,
            })
        );
    }

    async update(eap: Eap) {
        return await lastValueFrom(
            this.http.put(`${this.domain}/api/eap/update`, eap, {
                headers: this.headers,
            })
        );
    }

    async getPatternsList(vesselId: string) {
        return await lastValueFrom(
            this.http.get<EapLedPattern[]>(`${this.domain}/api/eap-led-pattern`, {
                headers: this.headers,
                params: { vesselId },
            })
        );
    }

    async createLedPattern(pattern) {
        return await lastValueFrom(
            this.http.put(`${this.domain}/api/eap-led-pattern/create`, pattern, {
                headers: this.headers,
            })
        );
    }

    async updateLedPattern(pattern) {
        return await lastValueFrom(
            this.http.put(`${this.domain}/api/eap-led-pattern/update`, pattern, {
                headers: this.headers,
            })
        );
    }

    async deleteLedPattern(pattern) {
        return await lastValueFrom(
            this.http.put(`${this.domain}/api/eap-led-pattern/delete`, pattern, {
                headers: this.headers,
            })
        );
    }
}
